import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { Share } from "@capacitor/share";
export async function shareVideo(title: string, id: string) {
  const url = new URL(
    import.meta.env.VITE_PUBLIC_APP_URL || window.location.href,
  );
  url.hash = "home";
  url.searchParams.set("video", id);
  const data = { title, text: `在樱桃视频发现：${title}`, url: url.toString() };
  // Production native sharing should use an HTTPS universal/app link from the API.
  if (Capacitor.isNativePlatform()) {
    await Share.share(data);
    return "已打开分享";
  }
  if (navigator.share) {
    await navigator.share(data);
    return "已打开分享";
  }
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(data.url);
    return "链接已复制";
  }
  throw new Error("当前浏览器不支持分享，请复制地址栏链接");
}
export async function bindNativeLifecycle(back: () => void) {
  if (!Capacitor.isNativePlatform()) return () => {};
  const state = await App.addListener("appStateChange", ({ isActive }) => {
    window.dispatchEvent(
      new CustomEvent("native-active", { detail: isActive }),
    );
  });
  const handler = await App.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack) back();
    else void App.minimizeApp();
  });
  return () => {
    void state.remove();
    void handler.remove();
  };
}
